module.exports = __webpack_public_path__ + "img/diners@2x.0b82db82.png";